import React, { useEffect, useState, useContext } from 'react';
import apis from '../../helpers/apis';
import { getLearnActionConfig } from '../../helpers/common';
import { LikeDislike } from '@intigral/shared';
import { __ } from '../../translations';
import { MixpanelContext } from '../../contexts/MixpanelContext';
import { EVENT, KEYS } from '../../contexts/MixpanelConstants';
import { getMixpanelVodProperties, getMixpanelLinearProperties } from '../../contexts/MixpanelHelper';
import { capitalizeFirstLetter } from '@intigral/utils/lib/helpers/string';
import { container } from '@intigral/domain/lib/DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import user from '../../helpers/user';
import { ILearnActionService } from '@intigral/domain/lib/application/services/LearnActionService';
import h, { getCountry } from '../../helpers/common';
import { log } from '@intigral/utils';

type LikeDislikeButtonProps = {
    itemGuid: string;
    item: any;
    handleLikeDislikePopupClose?: (open?: boolean) => void;
    style?: {
        float: string;
        marginTop: string;
    };
    className?: string;
};

export default function LikeDislikeButton({
    itemGuid,
    item,
    handleLikeDislikePopupClose,
    style,
    className,
    ...props
}: LikeDislikeButtonProps) {
    const [isContentLiked, setContentLiked] = useState(null);
    const learnActionConfig = getLearnActionConfig();
    const { track }: any = useContext(MixpanelContext);

    useEffect(() => {
        getContentRating();
    }, [itemGuid]);

    /***
     * get the content rating
     * @param {boolean} triggerMixPanelEvent - if true, will trigger mixpanel event
     * @param {string} clickActionType - click action type
     */
    const getContentRating = (triggerMixPanelEvent = false, clickActionType = '') => {
        if (itemGuid) {
            const searchParams = {
                userName: user.getUsername(),
                profileName: user.getProfileName(),
                itemGuid: itemGuid,
            };
            const learnActionService = container.resolve<ILearnActionService>(DI.SERVICES.ILearnActionService);
            learnActionService
                .getContentRating(user.getAPIKey(), searchParams, user.getIdentityToken())
                .then((_res) => {
                    let value = null;
                    if (_res?.isLike === true) {
                        value = 'like';
                    } else if (_res?.isLike === false) {
                        value = 'dislike';
                    }
                    if (triggerMixPanelEvent) {
                        addMixpanelEvent(clickActionType, value === null ? true : false);
                    }
                    setContentLiked(value);
                })
                .catch((_err) => {
                    setContentLiked(null);
                });
        }
    };

    const handleLikeDislike = (actionType = '') => {
        if (itemGuid) {
            setContentLiked(actionType === isContentLiked ? null : actionType);
            const searchParams = {
                userName: user.getUsername(),
                profileName: user.getProfileName(),
                itemGuid: itemGuid,
                action: actionType,
                device: h.getDevice(),
                country: getCountry(),
                // useCaseId: "string",
            };
            const learnActionService = container.resolve<ILearnActionService>(DI.SERVICES.ILearnActionService);
            learnActionService.addLikeDislike(user.getAPIKey(), searchParams, user.getIdentityToken()).then((_res) => {
                // addMixpanelEvent(actionType, actionType === isContentLiked ? true : false);
                if (_res === true && handleLikeDislikePopupClose) {
                    handleLikeDislikePopupClose();
                }
                getContentRating(true, actionType);
            });
        }
    };

    const addMixpanelEvent = (actionType, isRemove = false) => {
        track(isRemove ? EVENT.CONTENT_RATING.CONTENT_RATING_REMOVE : EVENT.CONTENT_RATING.CONTENT_RATING_ADD, {
            [KEYS.GENERAL.RATING_TYPE]: capitalizeFirstLetter(actionType),
            ...(item.category === 'VOD' ? getMixpanelVodProperties(item) : getMixpanelLinearProperties(item)),
        });
    };

    return learnActionConfig?.isLikeDislikeEnable ? (
        <LikeDislike
            likeLabel={__('like_content')}
            dislikeLabel={__('dislike_content')}
            isContentLiked={isContentLiked}
            onActionClick={handleLikeDislike}
            className={className}
            {...props}
        />
    ) : (
        <></>
    );
}
